import { folderSchemas } from "@redotech/redo-model/views/folders";
import { viewWithIdSchemas } from "@redotech/redo-model/views/views";
import * as z from "zod";
import { null as zNull } from "zod";
export const saveWorkOrderViewsAndFolders = {
  name: "saveWorkOrderViewsAndFolders" as const,
  input: z.object({
    folders: z.array(folderSchemas["work-orders"]),
    views: z.array(viewWithIdSchemas["work-orders"]),
  }),
  output: zNull(),
};
